import React from "react";
import { Icon } from "components";
import { topologyItems } from "utils/wizardHelpers/wizardHelpers";

export const DragItem = React.forwardRef(({ iconName, kind }, ref) => (
  <div
    className="panzoomDisabled cursor-pointer"
    ref={ref}
    style={{ zIndex: 2 }}
  >
    <Icon
      prefix="trox"
      iconName={
        // TODO: temporary solution for ISH. We should always show FAM icon (not FAME)
        iconName === "tech-symbol-fame"
          ? topologyItems[kind]?.iconName
          : iconName || topologyItems[kind]?.iconName
      }
      className="panzoomDisabled icon-32 d-flex align-items-center justify-content-center text-gray-700"
    />
  </div>
));
